<template>
  <div>
    <span class="mr-3"
      >{{ isImpersonated ? 'Przeglądasz jako: ' : 'Zalogowany jako: '
      }}<strong>{{ user.name }} {{ user.surname }}</strong></span
    >
    <SettingsDialog v-if="canViewManagePanel" />
    <ImpersonateDialog v-if="canImpersonateUsers && !isImpersonated" />
    <UnImpersonateDialog v-if="isImpersonated" />
    <v-tooltip bottom dark>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="logOut">
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </template>
      <span>Wyloguj się</span>
    </v-tooltip>
  </div>
</template>

<script>
import ImpersonateDialog from '@/components/shared/account/ImpersonateDialog.vue';
import UnImpersonateDialog from '@/components/shared/account/UnImpersonateDialog.vue';
import { createNamespacedHelpers } from 'vuex';
import SettingsDialog from '@/components/shared/account/SettingsDialog.vue';

const { mapActions, mapState, mapGetters } = createNamespacedHelpers('account');

export default {
  components: {
    ImpersonateDialog,
    UnImpersonateDialog,
    SettingsDialog
  },
  computed: {
    ...mapGetters(['permissions', 'canViewManagePanel']),
    ...mapState({
      user: state => state.user,
      isImpersonated: state => state.impersonation.isImpersonated.value
    }),
    canImpersonateUsers() {
      return this.permissions.includes('Lms_Administration_Impersonate_Users');
    },
    manageActive() {
      return this.$route.path.startsWith('/manage');
    }
  },
  methods: {
    ...mapActions(['singOut']),
    logOut() {
      this.singOut();
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped></style>
